import Table from './Table';

export default Table;


// WEBPACK FOOTER //
// ./src/yxyweb/common/components/grid-touch/index.jsx